// extracted by mini-css-extract-plugin
module.exports = {"info":"AllowenceType_info_3QcMU"};